module.exports = __webpack_public_path__ + "img/tag6.6de21a73.png";